import { useTranslation } from 'react-i18next';
import { ProductCategory } from 'graphql-query-contracts';
import { useChannelAdminContext } from 'hooks';
import { useHistory } from 'react-router-dom';
import { routes } from 'lane-shared/config';

export interface CategoryActions {
  label: string;
  onSelect: Function;
}
export interface CategoryActionsProps {
  onDelete: (category: ProductCategory) => void;
}

export function useGetActionsForCategories({ onDelete }: CategoryActionsProps): CategoryActions[] {
  const { t } = useTranslation();
  const history = useHistory();
  const { channel } = useChannelAdminContext();
  const channel_slug = channel?.slug || '';

  const editCategoryAction = (category: ProductCategory) => {
    history.push(
      routes.channelAdminEditCategoryForm
        .replace(':id', channel_slug)
        .replace(':categoryId', category.productCategoryId)
    );
  };
  
  const deleteCategoryAction = (category: ProductCategory) => {
    onDelete(category);
  };

  const actions = [
    {
      label: t('web.admin.content.sections.table.edit'),
      onSelect: (category: ProductCategory) => editCategoryAction(category),
    },
    {
      label: t('web.admin.content.sections.edit.delete'),
      onSelect: (category: ProductCategory) => deleteCategoryAction(category),
    },
  ];

  return actions;
}